// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*RoleHome.module.css*/
:root {
  --brand: #4a6cf7;
  --brand-dark: #3a59d0;
  --bg-light: #f7f9fc;
  --text: #1a1a2e;
  --muted: #555;
}

/* === Контейнер страницы === */
.RoleHome_roleHome__KWyhA {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--bg-light);
  color: var(--text);
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
}

/* === Заголовок роли (в одну строку) === */
.RoleHome_header__LKrbQ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem; /* расстояние между иконкой и текстом */
  width: 100%;
  max-width: 1200px;
  margin-bottom: 1.5rem;
  text-align: left;
}

.RoleHome_icon__eAVQO {
  font-size: 2.2rem;
  color: var(--brand);
  background-color: rgba(74, 108, 247, 0.1);
  border-radius: 0.8rem;
  padding: 0.7rem;
  flex-shrink: 0;
}

.RoleHome_headerText__3bWuf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.3;
}

.RoleHome_headerText__3bWuf h1 {
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}

.RoleHome_headerText__3bWuf p {
  color: var(--muted);
  font-size: 0.95rem;
  margin: 0.2rem 0 0;
  max-width: 700px;
}

/* === Раздел === */
.RoleHome_section__6t-pu {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto 2.5rem;
}

.RoleHome_sectionTitle__xexbG {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--brand);
  margin-bottom: 1.2rem;
  text-align: left;
}

/* === Сетка карточек === */
.RoleHome_cards__kV9ba {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  width: 100%;
  align-items: stretch;
}

/* === Карточка === */
.RoleHome_card__LZeDP {
  background: #fff;
  border-radius: 0.8rem;
  padding: 1rem 1.2rem;
  color: var(--text);
  text-decoration: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);
  transition: all 0.2s ease;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  min-height: 90px;
}

.RoleHome_card__LZeDP:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.12);
}

.RoleHome_card__LZeDP i {
  font-size: 1.6rem;
  color: var(--brand);
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.RoleHome_cardText__wpqgO {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.RoleHome_cardText__wpqgO h4 {
  font-size: 1rem;
  margin: 0;
  font-weight: 600;
  color: var(--text);
  line-height: 1.2;
}

.RoleHome_desc__lSYgs {
  font-size: 0.85rem;
  color: var(--muted);
  margin-top: 0.35rem;
  line-height: 1.3;
}

/* === Мобильная адаптация === */
@media (max-width: 768px) {
  .RoleHome_roleHome__KWyhA {
    padding: 1.2rem 1rem 4rem;
  }

  .RoleHome_header__LKrbQ {
    flex-direction: column; /* на телефоне — вертикально */
    text-align: center;
    gap: 0.6rem;
  }

  .RoleHome_icon__eAVQO {
    font-size: 2rem;
    padding: 0.5rem;
  }

  .RoleHome_headerText__3bWuf h1 {
    font-size: 1.5rem;
  }

  .RoleHome_headerText__3bWuf p {
    font-size: 0.9rem;
  }

  .RoleHome_cards__kV9ba {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .RoleHome_card__LZeDP {
    flex-direction: row;
    align-items: center;
    padding: 1rem;
    min-height: 80px;
  }

  .RoleHome_card__LZeDP i {
    font-size: 1.5rem;
  }

  .RoleHome_cardText__wpqgO h4 {
    font-size: 1rem;
  }

  .RoleHome_desc__lSYgs {
    font-size: 0.85rem;
  }
}

/* === ПК и большие экраны === */
@media (min-width: 1024px) {
  .RoleHome_cards__kV9ba {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1.2rem;
  }

  .RoleHome_card__LZeDP {
    flex-direction: row;
    align-items: center;
    padding: 1.2rem 1.4rem;
  }

  .RoleHome_card__LZeDP i {
    font-size: 1.6rem;
  }

  .RoleHome_desc__lSYgs {
    font-size: 0.85rem;
  }

  .RoleHome_sectionTitle__xexbG {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
}

/* === Очень широкие экраны === */
@media (min-width: 1600px) {
  .RoleHome_cards__kV9ba {
    grid-template-columns: repeat(4, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RoleHome/RoleHome.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS,EAAE,uCAAuC;EAClD,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB,EAAE,8BAA8B;IACtD,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,4DAA4D;IAC5D,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/*RoleHome.module.css*/\r\n:root {\r\n  --brand: #4a6cf7;\r\n  --brand-dark: #3a59d0;\r\n  --bg-light: #f7f9fc;\r\n  --text: #1a1a2e;\r\n  --muted: #555;\r\n}\r\n\r\n/* === Контейнер страницы === */\r\n.roleHome {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background: var(--bg-light);\r\n  color: var(--text);\r\n  min-height: 100%;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* === Заголовок роли (в одну строку) === */\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem; /* расстояние между иконкой и текстом */\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin-bottom: 1.5rem;\r\n  text-align: left;\r\n}\r\n\r\n.icon {\r\n  font-size: 2.2rem;\r\n  color: var(--brand);\r\n  background-color: rgba(74, 108, 247, 0.1);\r\n  border-radius: 0.8rem;\r\n  padding: 0.7rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.headerText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  line-height: 1.3;\r\n}\r\n\r\n.headerText h1 {\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.headerText p {\r\n  color: var(--muted);\r\n  font-size: 0.95rem;\r\n  margin: 0.2rem 0 0;\r\n  max-width: 700px;\r\n}\r\n\r\n/* === Раздел === */\r\n.section {\r\n  width: 100%;\r\n  max-width: 1400px;\r\n  margin: 0 auto 2.5rem;\r\n}\r\n\r\n.sectionTitle {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: var(--brand);\r\n  margin-bottom: 1.2rem;\r\n  text-align: left;\r\n}\r\n\r\n/* === Сетка карточек === */\r\n.cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 1rem;\r\n  width: 100%;\r\n  align-items: stretch;\r\n}\r\n\r\n/* === Карточка === */\r\n.card {\r\n  background: #fff;\r\n  border-radius: 0.8rem;\r\n  padding: 1rem 1.2rem;\r\n  color: var(--text);\r\n  text-decoration: none;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  min-height: 90px;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.card i {\r\n  font-size: 1.6rem;\r\n  color: var(--brand);\r\n  flex-shrink: 0;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.cardText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  text-align: left;\r\n}\r\n\r\n.cardText h4 {\r\n  font-size: 1rem;\r\n  margin: 0;\r\n  font-weight: 600;\r\n  color: var(--text);\r\n  line-height: 1.2;\r\n}\r\n\r\n.desc {\r\n  font-size: 0.85rem;\r\n  color: var(--muted);\r\n  margin-top: 0.35rem;\r\n  line-height: 1.3;\r\n}\r\n\r\n/* === Мобильная адаптация === */\r\n@media (max-width: 768px) {\r\n  .roleHome {\r\n    padding: 1.2rem 1rem 4rem;\r\n  }\r\n\r\n  .header {\r\n    flex-direction: column; /* на телефоне — вертикально */\r\n    text-align: center;\r\n    gap: 0.6rem;\r\n  }\r\n\r\n  .icon {\r\n    font-size: 2rem;\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .headerText h1 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .headerText p {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .cards {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .card {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    padding: 1rem;\r\n    min-height: 80px;\r\n  }\r\n\r\n  .card i {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .cardText h4 {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .desc {\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n\r\n/* === ПК и большие экраны === */\r\n@media (min-width: 1024px) {\r\n  .cards {\r\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n    gap: 1.2rem;\r\n  }\r\n\r\n  .card {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    padding: 1.2rem 1.4rem;\r\n  }\r\n\r\n  .card i {\r\n    font-size: 1.6rem;\r\n  }\r\n\r\n  .desc {\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .sectionTitle {\r\n    font-size: 1.1rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n}\r\n\r\n/* === Очень широкие экраны === */\r\n@media (min-width: 1600px) {\r\n  .cards {\r\n    grid-template-columns: repeat(4, 1fr);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roleHome": `RoleHome_roleHome__KWyhA`,
	"header": `RoleHome_header__LKrbQ`,
	"icon": `RoleHome_icon__eAVQO`,
	"headerText": `RoleHome_headerText__3bWuf`,
	"section": `RoleHome_section__6t-pu`,
	"sectionTitle": `RoleHome_sectionTitle__xexbG`,
	"cards": `RoleHome_cards__kV9ba`,
	"card": `RoleHome_card__LZeDP`,
	"cardText": `RoleHome_cardText__wpqgO`,
	"desc": `RoleHome_desc__lSYgs`
};
export default ___CSS_LOADER_EXPORT___;
